import { route } from 'preact-router';
import * as visitsApi from '../../api/visits';
import { fetchHistorialCliente } from '../../api/clients';
import {
  visits,
  clients,
  currentVisit,
  currentClient,
  clientVisits,
  loading,
  success,
} from '../state';
import { loadData } from './data.actions';
import type { VisitTipo } from '../../api/types';
import { getCoordsBestEffort } from '../../utils/geolocation';

export async function crearVisita(clientId: string, fechaProgramada: string, tipo?: VisitTipo) {
  await visitsApi.crearVisita(clientId, fechaProgramada, tipo);
  await loadData();
}

export async function abrirVisita(id: string) {
  loading.value = true;
  await loadData();
  currentVisit.value = visits.value.find((v) => v.id === id) || null;
  loading.value = false;
  route(`/visitas/${id}`);
}

export async function tomarVisita(id: string) {
  await visitsApi.tomarVisita(id);
  success.value = 'Visita tomada.';
  await abrirVisita(id);
}

export async function checkin(id: string) {
  const coords = await getCoordsBestEffort();
  await visitsApi.checkin(id, coords);
  await abrirVisita(id);
}

export async function guardarTrabajo(id: string, descripcion?: string, ticket?: string) {
  await visitsApi.guardarTrabajo(id, descripcion, ticket);
  await abrirVisita(id);
}

export async function agregarFoto(id: string, dataUrl: string, tipo: 'antes' | 'despues') {
  await visitsApi.agregarFoto(id, dataUrl, tipo);
  await abrirVisita(id);
}

export async function guardarFirma(id: string, dataUrl: string, nombre: string) {
  await visitsApi.guardarFirma(id, dataUrl, nombre);
  await abrirVisita(id);
}

export async function checkout(id: string) {
  const coords = await getCoordsBestEffort();
  await visitsApi.checkout(id, coords);
  success.value = 'Visita cerrada. Próxima visita creada automáticamente.';
  await loadData();
  route('/agenda');
}

export async function marcarFallida(id: string, motivo: string) {
  await visitsApi.marcarFallida(id, motivo);
  success.value = 'Visita marcada como fallida. Se creó una visita de reemplazo.';
  await loadData();
  route('/agenda');
}

export async function posponerVisita(id: string, motivo: string, dias: string | number) {
  await visitsApi.posponerVisita(id, motivo, parseInt(String(dias)) || 7);
  success.value = 'Visita pospuesta.';
  await loadData();
  route('/agenda');
}

export async function reasignarVisita(
  id: string,
  tecnicoId: string | null,
  fecha: string | null,
  motivo: string | null
) {
  await visitsApi.reasignarVisita(id, tecnicoId, fecha, motivo);
  success.value = 'Visita reasignada.';
  await loadData();
  route('/agenda');
}

export async function cancelarVisita(id: string, motivo: string) {
  await visitsApi.cancelarVisita(id, motivo);
  success.value = 'Visita cancelada.';
  await loadData();
  route('/agenda');
}

export async function verHistorial(id: string) {
  loading.value = true;
  currentClient.value = clients.value.find((c) => c.id === id) || null;
  clientVisits.value = await fetchHistorialCliente(id);
  loading.value = false;
  route(`/clientes/${id}`);
}

// Used by views on mount (direct navigation / page refresh via a deep link)
// to populate data without pushing a duplicate history entry.
export async function ensureVisitLoaded(id: string) {
  if (currentVisit.value?.id === id) return;
  loading.value = true;
  if (!visits.value.length) await loadData();
  currentVisit.value = visits.value.find((v) => v.id === id) || null;
  loading.value = false;
}

export async function ensureClientHistorialLoaded(id: string) {
  if (currentClient.value?.id === id && clientVisits.value.length) return;
  loading.value = true;
  if (!clients.value.length) await loadData();
  currentClient.value = clients.value.find((c) => c.id === id) || null;
  clientVisits.value = await fetchHistorialCliente(id);
  loading.value = false;
}
